import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PoModule } from '@po-ui/ng-components';
import { PoPageLoginModule } from '@po-ui/ng-templates';
import { ContextModule } from '../Context/context.module';
import { MainPageComponent } from './mainpage/mainpage.component';
import { GaugeChartModule } from '../cp-gauge/cp-gauge.module';
import { LoginComponent } from './login/login.component';
import { ProgressChartModule } from '../cp-progresschart/cp-progresschart.module';
import { TaskModule } from '../Task/task.module';
import { InputModule } from '../Input/input.module';

@NgModule({
  declarations: [
    MainPageComponent,
    LoginComponent
  ],
  imports: [
    CommonModule,
    PoModule,
    PoPageLoginModule,
    ContextModule,
    GaugeChartModule,
    ProgressChartModule,
    TaskModule,
    InputModule
  ]
})
export class HomeModule { }
